import { render } from "./ImagePickField.vue?vue&type=template&id=2c405c29&scoped=true"
import script from "./ImagePickField.vue?vue&type=script&lang=js"
export * from "./ImagePickField.vue?vue&type=script&lang=js"

import "./ImagePickField.vue?vue&type=style&index=0&id=2c405c29&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c405c29"]])

export default __exports__